import { View } from "../../Core";
import Vue from "vue";
import { Uri } from "../../Core/Helpers/Uri";
import * as ajax from "@brightspark/sparkling-ajax-js";
import { IServiceResult } from "../../Models/IServiceResult";


enum Action {
    GetGroupMembers,
    ChangeTrainingGroup,
}

interface IDefaultSchedule {
    daysOfWeek: Array<string>;
    startTime: string;
    endTime: string;
}

interface ITrainingGroup {
    code: string;
    periodStart: string;
    periodEnd: string;
    defaultSchedules: Array<IDefaultSchedule>;
}

interface IClient {
    id: string;
    firstName: string;
    lastName: string;
    registeredResidenceName: string;
    personalCode: string;
    email: string;
    phoneNumber: string;
    isAlreadyInActiveGroup: boolean;
    trainingGroups: Array<ITrainingGroup>;

    cancelContract: boolean;
    changeGroup: boolean;
    newGroupId: string;
    newCancellationReason: string;

    validationResults: any;
}

class ViewDataModel {
    public currentUserId: string;
    public changeGroup: boolean;
    public anotherPayer: boolean;
    public attendeeEInvoice: boolean;
    public registrantEInvoice: boolean;
    public payerEInvoice: boolean;
    public registeredResidenceId: string;
    public otherRegisteredResidenceId: string;
    public selectedChildId: string;
    public children: Array<IClient> = new Array();
    public selectedPayerId: string;
    public payers: Array<IClient> = new Array();

    public trainingGroups: Array<ITrainingGroup> = new Array();
    public defaultSchedules: Array<IDefaultSchedule> = new Array();
}

export class RegisterView extends View<RegisterView> {
    private _viewData: ViewDataModel = window.__VIEW_DATA;

    public constructor() {
        super();
        this.SetupVue();
    }

     SetupVue() {
        var _data = {
            selectedChildId: this._viewData.selectedChildId,
            selectedPayerId: this._viewData.selectedPayerId,
            anotherPayer: this._viewData.anotherPayer,
            attendeeEInvoice: this._viewData.attendeeEInvoice,
            registrantEInvoice: this._viewData.registrantEInvoice,
            payerEInvoice: this._viewData.payerEInvoice,
            registeredResidenceId: this._viewData.registeredResidenceId,
            otherRegisteredResidenceId: this._viewData.otherRegisteredResidenceId,
            isCompany: true,
            children: this._viewData.children,
            payers: this._viewData.payers,

            trainingGroups: this._viewData.trainingGroups,
            defaultSchedules: this._viewData.defaultSchedules,
            changeGroup: this._viewData.changeGroup
        };

         let v = new Vue({
             el: ".app",
             data: _data,
             mounted() {
                 //this.updateGroupMembers();
             },
             computed: {
                 selectedChild: (): IClient => {

                     if (!_data.selectedChildId) {
                         return {} as IClient;
                     }
                     return _data.children.find(x => x.id === _data.selectedChildId) as IClient;
                 },
                 selectedPayer: (): IClient => {
                     if (!_data.selectedPayerId) {
                         return {} as IClient;
                     }
                     return _data.payers.find(x => x.id === _data.selectedPayerId) as IClient;
                 },
             },
             methods: {
                     //changeGroup(gm: IClient) {
                     //    var data = {
                     //        groupMemberId: gm.id,
                     //        newTrainingGroupId: gm.newGroupId,
                     //        reason: gm.newCancellationReason
                     //    };

                     //    ajax(Uri.getUri(Action[Action.ChangeTrainingGroup]), { dataType: "json", method: "post", data: data })
                     //        .done((res: IServiceResult<IClient>) => {
                     //            if (!res.isSuccess) {
                     //                gm.validationResults = res.validationResults;
                     //                return;
                     //            }
                     //            this.updateGroupMembers();
                     //        });
                     //},

                     //updateGroupMembers() {
                     //    ajax(Uri.getUri(Action[Action.GetGroupMembers]), { dataType: "json", method: "get" })
                     //        .done((res: Array<IClient>) => {
                     //            return _data.children = prepareGroupMembers(res);
                     //        });
                     //},
                 }
             });

        //function prepareGroupMembers(groupMembers: Array<IClient>): Array<IClient> {
        //    groupMembers.forEach(x => {
        //        x.cancelContract = false;
        //        x.changeGroup = false;
        //        x.newGroupId = "";
        //        x.validationResults = {};
        //    });
        //    return groupMembers;
        //}
    }
}


// WEBPACK FOOTER //
// ./www/js/Pages/TrainingGroup/RegisterView.ts